export default __webpack_public_path__ + "static/media/przez.1f9e5e65.svg";